import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default (
  <Route key="/consumer/features/reshape-face-in-video" element={<DefaultConsumerLayout />}>
    <Route path="consumer/features/reshape-face-in-video" element={<AsyncPage />} />
  </Route>
);
